import { render, staticRenderFns } from "./IconTravel.vue?vue&type=template&id=79e8d13a&"
import script from "./IconTravel.vue?vue&type=script&lang=js&"
export * from "./IconTravel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports